import { tx } from '@transifex/native';

import config from './config';

export const setupi18n = () => {
  tx.init({
    token: config.transifexToken,
    secret: config.transifexSecret,
  });
};
